"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(fn){var defer=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(){return setTimeout(fn,0)};return defer(fn)};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/StringFunctions/defer.js
// module id = 765
// module chunks = 0